export default "__VITE_ASSET__9af97_0k__"